import ApiUrl from 'src/config/api';

export const getUrl = (restaurantId, imageId) => `${ApiUrl}/api/restaurant/restaurants/${restaurantId}/images/${imageId}`;
